































































import Vue from "vue";
import iwInputSelect from "@/shared/components/buildingBlocks/InputSelect.vue";
import iwDropdown from "@/shared/components/Dropdown.vue";
import { mapState } from "vuex";
import { ALL_PROPERTY_TYPES } from "@/shared/scripts/helpers/constants/classifiedTypes";

export default Vue.extend({
    name: "PropertyTypeFilter",
    components: {
        iwInputSelect: iwInputSelect,
        iwDropdown: iwDropdown
    },
    props: {
        isMobile: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function() {
        return {
            triggerStyle: "filter--mobile" as string,
            selectedPropertyType: "ALL" as string,
            internalPropertyType: "ALL" as string
        };
    },
    computed: {
        ...(mapState("MyClassifiedsModule", ["filterPropertyType"]) as { filterPropertyType: () => string }),
        options: function(): Array<Record<string, unknown>> {
            const options: Array<Record<string, unknown>> = [
                {
                    "label": this.$t("all_kind"),
                    "value": "ALL"
                }
            ];
            ALL_PROPERTY_TYPES.forEach((type) => {
                options.push({
                    "label": this.$t(type.toLowerCase()),
                    "value": type
                });
            });
            return options;
        },
        title: function(): string {
            if (this.filterPropertyType && this.filterPropertyType !== "ALL") {
                return this.filterPropertyType.toLowerCase();
            }
            return "all_kind";
        }
    },
    mounted: function() {
        this.selectedPropertyType = this.filterPropertyType || "ALL";
        this.internalPropertyType = this.filterPropertyType || "ALL";

        if (this.isMobile) {
            this.triggerStyle = "filter--mobile";
        } else {
            this.triggerStyle = "filter filter--result-list";
        }
    },
    methods: {
        filterValue: function(propertyType: string) {
            this.$store.commit("MyClassifiedsModule/setFilterPropertyType", propertyType);
            this.$emit("filter-value", propertyType);
        },
        apply: function() {
            this.$store.commit("MyClassifiedsModule/setFilterPropertyType", this.internalPropertyType);
            this.$emit("filter-value", this.internalPropertyType);
            this.$emit("close-mobile-overlay");
        }
    }
});
